module.exports = __webpack_public_path__ + "static/media/c39.bae5418e.png";